import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import GetAppSharpIcon from '@material-ui/icons/GetAppSharp';

import downloadFiles from '../../utils/downloadFiles';
import { formatDate, formatMoney, formatFractionWithMask } from '../../utils/formatter';

import SnackbarComponent from '../../components/Snackbar';
import TableWithSorting from '../../components/TableWithSorting';

import { fundQuota } from '../../redux-flow/containers/QuotaHistoryTable/fundQuota';
import { exportQuota } from '../../redux-flow/containers/QuotaHistoryTable/exportQuota';

import useStyles from './style';

const columns = [
  {
    id: 'date',
    label: 'Data',
    minWidth: 100,
    align: 'left',
    format: value => formatDate(value),
  },
  {
    id: 'equityQuotaDisplay',
    label: 'Cota Patrimonial',
    minWidth: 170,
    align: 'left',
    format: value => formatMoney(value),
  },
  {
    id: 'netEquityDisplay',
    label: 'Patrimônio Líquido',
    minWidth: 170,
    align: 'left',
    format: value => formatMoney(value),
  },
  {
    id: 'indexPointValueDisplay',
    label: 'Valor em pontos do índice',
    minWidth: 170,
    align: 'left',
    format: value => formatFractionWithMask(value, 2),
  },
];

const QuotaHistoryTableSorting = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [quotas, setQuotas] = useState([]);
  const { fundQuotaReducer, exportQuotaReducer } = useSelector(state => state);
  const { ticker } = useRouteMatch().params;

  useEffect(() => {
    dispatch(fundQuota(ticker));
  }, [ticker]);

  useEffect(() => {
    if (exportQuotaReducer.data.size > 0) downloadFiles(exportQuotaReducer.data, 'export-quota-history.xlsx');
  }, [exportQuotaReducer.data]);

  useEffect(() => {
    if (fundQuotaReducer.data.quotas) {
      setQuotas(fundQuotaReducer.data.quotas);
    }
  }, [fundQuotaReducer.data.quotas]);

  return (
    <>
      <SnackbarComponent
        msg="Carregando..."
        openProps={fundQuotaReducer.loading || exportQuotaReducer.loading || false}
        variant="info"
      />
      <TableWithSorting
        columns={columns}
        rows={quotas}
        title="Histórico de cotas"
      />
      <Button
        variant="outlined"
        color="primary"
        onClick={() => dispatch(exportQuota(ticker))}
        type="button"
        className={classes.button}
      >
        <GetAppSharpIcon className={classes.buttonIcon} />
        Baixar histórico completo
      </Button>
    </>
  );
};

export default QuotaHistoryTableSorting;
